export var BIRONEX_INIT = 0;
export var BIRONEX_SUCCESS = 1;
export var BIRONEX_ERROR = -100;



// WEBPACK FOOTER //
// ./src/constants/bironexState.js